import { render, staticRenderFns } from "./政策交易土地招商.vue?vue&type=template&id=273b0fd2&scoped=true"
import script from "./政策交易土地招商.vue?vue&type=script&lang=js"
export * from "./政策交易土地招商.vue?vue&type=script&lang=js"
import style0 from "./政策交易土地招商.vue?vue&type=style&index=0&id=273b0fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b0fd2",
  null
  
)

export default component.exports